import React from "react";

/*
 * requiredバッヂ
 */
export default function BudgeRequire() {
  return (
    <span className="py-0.5 px-2 ml-2 text-[10px] font-bold leading-[18px] text-white bg-color-red_error rounded md:text-[12px] min-w-[42px]">
      必須
    </span>
  );
}
